import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TrialBalanceLayer from "../../components/Accounts/TrialBalanceLayer";

const TrialBalancePage = () => {
  return (
    <MasterLayout>
      <TrialBalanceLayer />
    </MasterLayout>
  );
};

export default TrialBalancePage;
